// local-axios-http-request.ts

import { Injectable } from '@angular/core';
import axios, { AxiosResponse } from 'axios';

import {
  EMPTY,
  Observable,
  from,
  throwError
} from 'rxjs';

import {
  catchError,
  map,
  switchMap
} from 'rxjs/operators';

import { Storage } from '@ionic/storage';
import { IHttpRequest } from './IHttpRequest ';

@Injectable({
  providedIn: 'root'
})
export class LocalAxiosHttpRequest implements IHttpRequest {

  private readonly tokenKey = 'token';

  constructor(
    private storage: Storage
  ) {}

  public get<T = any>(url: string, params?: any): Observable<T> {

    return this.sendRequest<T>(accessToken =>
      axios.get<T>(url, {
        params,
        headers: this.createHeaders(accessToken)
      })
    );
  }

  public post<T = any>(url: string, body: any): Observable<T> {

    return this.sendRequest<T>(accessToken =>
      axios.post<T>(url, body, {
        headers: this.createHeaders(accessToken)
      })
    );
  }

  public postWithHeaderParams<T = any>(url: string, body: any, params: any): Observable<T> {
    return this.sendRequest<T>(accessToken =>
      axios.post<T>(url, body, {
        params,
        headers: this.createHeaders(accessToken)
      })
    );
  }

  private sendRequest<T>(requestFactory: (accessToken: string) => Promise<AxiosResponse<T>>): Observable<T> {
    return from(
      this.storage.get(this.tokenKey)
    ).pipe(
      switchMap(accessToken => {
        if (!accessToken) {
          return throwError({
            status: 401,
            message: 'Local access token not found'
          });
        }

        return from(requestFactory(accessToken));
      }),

      map(response => response.data),

      catchError(error =>
        this.handleAxiosError(error)
      )
    );
  }

  private createHeaders(accessToken: string): Record<string, string> {

    return {
      Authorization: `Basic ${accessToken}`,
      'Content-Type': 'application/json'
    };
  }

  private handleAxiosError(error: any): Observable<never> {
    const status = error?.response?.status || error?.status;

    const data = error?.response?.data;

    return throwError({
      status: status || 500,

      message:
        data?.message ||
        data?.error ||
        error?.message ||
        'Internal Server Error',

      _body:
        typeof data === 'string'
          ? data
          : JSON.stringify(data)
    });
  }
}


// WEBPACK FOOTER //
// ./src/infra/localAxiosHttpRequest.ts